import React from "react";
import { Link } from "react-router-dom";
import { PageDishesWrapper } from "../components/Layout/PageDishesWrapper";

const Bestdeals = ({
  image,
  Title,
  price_small,
  price_medium,
  id,
  category,
}) => {
  return (
    <PageDishesWrapper>
      <div className="mt-3 d-flex flex-column control-div">
        <div className="d-flex align-items-start">
          <img src={image[0].url} className="small-img" alt={Title} />

          <div className="d-flex ml-2 flex-column">
            <h6>
              <Link to={`/pizza-product/${Title}/${category}/${id}`}>
                {Title}
              </Link>
            </h6>
            <span>
              <small>$</small> {price_small} -<small>$</small> {price_medium}
            </span>
          </div>
        </div>
      </div>
      <div className="border-line ml-3 mr-3 mt-3"></div>
    </PageDishesWrapper>
  );
};

export { Bestdeals as default };
